<template>
  <v-dialog
    v-model="show"
    max-width="500px"
    persistent
  >
    <v-card>
      <v-card-title v-if="message">
        {{ title }}
      </v-card-title>
      <v-card-text>
        <div class="text-center">
          <v-icon size='180' color='amber' class='ma-0 pa-0'>mdi-alert</v-icon>
        </div>
        {{ message }}
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn :color="cancelColor" text @click="cancelEvent">{{ cancelText }}</v-btn>
        <v-btn :color="acceptColor" text @click="acceptEvent">{{ acceptText }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    acceptText: {
      type: String,
      default: "Accept"
    },
    acceptColor: {
      type: String,
      default: "red"
    },
    cancelText: {
      type: String,
      default: "Cancel"
    },
    cancelColor: {
      type: String,
      default: "green"
    }
  },
  data: () => ({
    show: false,
    title: "",
    message: ""
  }),
  mounted() {
    this.$emit('mounted');
  },
  methods: {
    setMessage(title, message) {
      this.title = title;
      this.message = message;
    },
    acceptEvent() {
      this.$emit('accept');
      this.close();
    },
    cancelEvent() {
      this.$emit('cancel');
      this.close();
    },
    open() {
      this.show = true;
    },
    close() {
      this.show = false;
    },
    reset() {
      this.title = "";
      this.message = "";
    }
  }
}
</script>
